import FormattedMessage from 'I18n/components/FormattedMessage';
import { UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const ApprovalEditPanelTooltipI18n = props => {
  const {
    approvalType
  } = props;
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.MARKETING_EMAIL"
        });
      }
    case 'LANDING_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.LANDING_PAGE"
        });
      }
    case 'SITE_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.SITE_PAGE"
        });
      }
    case 'BLOG_POST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.BLOG_POST"
        });
      }
    case 'DEAL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.DEAL"
        });
      }
    case 'KNOWLEDGE_ARTICLE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.KNOWLEDGE_ARTICLE"
        });
      }
    default:
      throw new UnreachableI18nCaseError(approvalType);
  }
};
export default ApprovalEditPanelTooltipI18n;